import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { getSessionData } from "@repo/shared-utils/common-utils";
import { encryptedRequest } from "../core/api.client";

export interface ISequencingAPIData {
  data: IFeatureDetails[];
  statusCode: number;
  status: string;
  message: string;
}
export interface IFeatureDetails {
  featurename: string;
  featureNavigationLink: string;
  webLink: string;
  featureDesc: string;
  featureTechPlatform: string;
  featurePlatform: string;
  featureId: string;
  featureIconLink: string;
  featurePromoText: string;
  status: string;
}

export interface INudgesAPIData {
  data: INudgeDetails[];
  statusCode: number;
  status: string;
  message: string;
}

export interface INudgeDetails {
  module: string;
  submodule: string;
  section: string;
  tagName: string;
  tagValue: string;
  tagType: string;
  tagSubType: string;
  icon: string;
  height: string;
  width: string;
  position: string;
  backgroundColor: string;
  xCoordinate: string;
  yCoordinate: string;
  CTA: string | null;
  text: {
    fontSize: string;
    fontColor: string;
    Title: string;
  };
  versions: string[];
  priority: number;
  isProd: boolean;
  isStatic: boolean;
  displayId: string | null;
  nudgeDisplayType: string;
  jsonFile: string | null;
}

export const dynamicSequencingAPI = async (
  moduleName: string,
  sectionFeatureId: string,
  pageId: string,
  dynamicSequencingAppVersion?: string,
  langPreference?: string
): Promise<ISequencingAPIData> => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  const { custType } = await getSessionData();
  try {
    const response: ISequencingAPIData = await encryptedRequest({
      method: "POST",
      url: API_PATHS.iconPosition,
      data: {
        mobileNo,
        custType,
        module: moduleName,
        pageId,
        sectionFeatureId,
        appVersion: dynamicSequencingAppVersion,
        langPreference,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const dynamicNudgesAPI = async (
  module: string,
  appVersion: string,
  fetchAllNudges = false
): Promise<INudgesAPIData> => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  const sessionData = await getSessionData();
  const custType = sessionData?.custType || "NTB";
  try {
    const response: INudgesAPIData = await encryptedRequest({
      method: "POST",
      url: API_PATHS.dynamicNudges,
      data: {
        mobileNo,
        module,
        custType,
        appVersion,
        fetchAllNudges,
      },
    });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
